import type { GetUncheckedCampaignPositionsGroupedCheckTypeInline } from '@/services/ws-operations/src/main/resources/rest-api';

export enum ApprovalStatus {
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export interface ApprovalRouteParams {
  status: ApprovalStatus;
}

export enum ScreenshotManagementScope {
  CAMPAIGNS = 'CAMPAIGNS',
  APPROVALS = 'APPROVALS',
  DONE = 'DONE',
  HIDDEN = 'HIDDEN',
}

export enum DigitalOperationStatus {
  ALL = 'ALL',
  READY_TO_PUSH = 'READY_TO_PUSH',
  PUSH_UPDATE = 'PUSH_UPDATE',
  PENDING = 'CREATIVE_PENDING',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  REQUESTED = 'CREATIVE_REQUESTED',
  RECEIVED = 'CREATIVE_RECEIVED',
  READY = 'READY',
  RUNNING = 'RUNNING',
  DECLINED = 'DECLINED',
  ISSUES = 'ISSUES',
  HIDDEN = 'HIDDEN',
  FINISHED = 'FINISHED',
}

export interface CampaignManagementRouteParams {
  status: DigitalOperationStatus;
}

export interface QualityAssuranceRouteParams {
  checkType: GetUncheckedCampaignPositionsGroupedCheckTypeInline;
}
